import DropdownOption from "@/entities/DropdownOption";
import ProfileCountries from "@/entities/locationEntities/ProfileCountries";
import onlyPrimaryCountries from "@/helpers/locations/onlyPrimaryCountries";

interface GetCountryRelatedValue<T> {
  countries: DropdownOption[],
  primary: T,
  onlyUSA: T,
  onlyCanada: T,
  defaultValue: T,
}

const getCountryRelatedValue = <T>({
    countries,
    primary,
    onlyCanada,
    onlyUSA,
    defaultValue,
  }: GetCountryRelatedValue<T>) => {

  if (countries.length === 0 || countries.length === 2 && onlyPrimaryCountries(countries)) {
    return primary;
  }

  if (countries.length > 2) {
    return defaultValue;
  }

  if (countries[0].name === ProfileCountries.USA) {
    return onlyUSA;
  }

  if (countries[0].name === ProfileCountries.CANADA) {
    return onlyCanada;
  }

  return defaultValue;
}

export default getCountryRelatedValue;